import styled, { css } from 'styled-components';

export const Button = styled.div`
  width: 47.5%;
  margin-right: 2.5%;
  box-sizing: border-box;
  border: 2px solid black;
  padding: 0.5rem 0.25rem;
  font-weight: 500;
  font-size: 0.7rem;
  text-align: center;
  text-transform: uppercase;
  margin-bottom: 0.5rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover{
    background: rgba(0,0,0,0.1);
  }

  ${(props) => props.active && css`
    background: black;
    color: ${props.theme.colors.beige};
    &:hover{
      background: black;
    }
  `}
  
`

export const Content = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  margin-top: 0.75rem;
`;

export const Title = styled.div`
  font-family: ${(props) => props.theme.fonts.alt};
  text-transform: uppercase;
`;

const Wrapper = styled.div`
  width: 100%;
  margin-top: 2rem;
`;

export default Wrapper;